/**
 * Divayur Mobile Menu Enhancements
 * Custom script to enhance mobile menu animations and interactions
 */

document.addEventListener('DOMContentLoaded', function() {
  // Variables
  const headerDrawer = document.querySelector('.header-drawer');
  const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
  const hamburgerMenuButton = document.querySelector('.header__icon--menu');
  const drawerCloseButton = document.querySelector('.drawer__close-button');
  const menuOverlay = document.querySelector('.menu-overlay');
  
  // Skip if not on mobile or elements don't exist
  if (!headerDrawer || !hamburgerMenuButton) return;
  
  // Add animation order to menu items
  menuItems.forEach(function(item, index) {
    // Check if item is an HTMLElement
    if (item instanceof HTMLElement) {
      item.style.setProperty('--animation-order', index.toString());
    }
  });
  
  // Enhance menu open animation - improved to prevent flickering
  function enhanceDrawerOpen() {
    if (headerDrawer && headerDrawer.classList.contains('animate')) {
      // Make sure overlay shows properly
      if (menuOverlay instanceof HTMLElement) {
        menuOverlay.setAttribute('aria-hidden', 'false');
      }
      
      // Ensure smooth animation by properly setting the initial state
      requestAnimationFrame(function() {
        // Delay applying visibility to avoid FOUC (Flash Of Unstyled Content)
        setTimeout(function() {
          // Set menu item initial state for proper transitions
          menuItems.forEach(function(item, index) {
            if (item instanceof HTMLElement) {
              item.style.setProperty('--animation-order', index.toString());
            }
          });
        }, 10); // Small delay to ensure CSS transitions apply smoothly
      });
    }
  }
  
  // Enhance menu close animation - improved to prevent flickering
  function enhanceDrawerClose() {
    if (menuOverlay instanceof HTMLElement) {
      // Just set attribute and let CSS handle the transition
      menuOverlay.setAttribute('aria-hidden', 'true');
    }
  }
  
  // Listen for drawer open/close - improved handling
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class' && headerDrawer) {
        if (headerDrawer.classList.contains('animate')) {
          // Wait a frame to ensure CSS has been applied
          requestAnimationFrame(function() {
            // Menu is opening
            headerDrawer.classList.remove('closing');
            enhanceDrawerOpen();
          });
        } else {
          // Menu is closing
          headerDrawer.classList.add('closing');
          enhanceDrawerClose();
          
          // Remove closing class after a fixed duration - more reliable than transitionend
          setTimeout(function() {
            if (headerDrawer) {
              headerDrawer.classList.remove('closing');
            }
          }, 400); // Match the CSS transition duration
        }
      }
    });
  });
  
  // Start observing
  if (headerDrawer) {
    observer.observe(headerDrawer, { attributes: true });
  }
  
  // Add toggle functionality for submenu arrows
  const submenuToggles = document.querySelectorAll('.menu-drawer__toggle');
  
  submenuToggles.forEach(function(toggle) {
    toggle.classList.add('mobile-menu-toggle');
    toggle.addEventListener('click', function() {
      this.classList.toggle('open');
    });
  });
  
  // Enhance the hamburger button with haptic feedback (vibration) if available
  if (hamburgerMenuButton) {
    hamburgerMenuButton.addEventListener('click', function() {
      if ('vibrate' in navigator) {
        navigator.vibrate(10); // Subtle vibration
      }
    });
  }
  
  // Add touch swipe to close drawer - simplified for reliability
  let touchStartX = 0;
  let touchEndX = 0;
  
  if (headerDrawer) {
    // Simplified touch handling to prevent blackouts and errors
    headerDrawer.addEventListener('touchstart', function(e) {
      if (e && e.touches && e.touches[0]) {
        touchStartX = e.touches[0].clientX;
      }
    }, { passive: true });
    
    headerDrawer.addEventListener('touchend', function(e) {
      if (e && e.changedTouches && e.changedTouches[0]) {
        touchEndX = e.changedTouches[0].clientX;
        
        // Right swipe to close drawer (for RTL: left swipe)
        if (touchEndX - touchStartX > 100 && drawerCloseButton) {
          // Simple approach - close the drawer by simulating Escape key
          const closeEvent = new KeyboardEvent('keydown', {
            key: 'Escape',
            bubbles: true
          });
          document.dispatchEvent(closeEvent);
        }
      }
    }, { passive: true });
  }
});
